export var UserServiceRelationshipType;

(function (UserServiceRelationshipType) {
  UserServiceRelationshipType["NONE"] = "NONE";
  UserServiceRelationshipType["LEAD"] = "LEAD";
  UserServiceRelationshipType["SUBSCRIBER"] = "SUBSCRIBER";
  UserServiceRelationshipType["CUSTOMER"] = "CUSTOMER";
})(UserServiceRelationshipType || (UserServiceRelationshipType = {}));